import { render, staticRenderFns } from "./ValidacionHistorico.vue?vue&type=template&id=65bc78c5&"
import script from "./ValidacionHistorico.vue?vue&type=script&lang=js&"
export * from "./ValidacionHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports